module.exports = __webpack_public_path__ + "static/media/completed_coupon_1.11685671.svg";